import API from "../http-common";

/**
 * Create a new log entry
 * @param {Object} data - Log payload
 */
const create = (data) => {
	return API.post("/log", data);
};

/**
 * Retrieve recent logs
 * @param {Object} params
 * @param {number} [params.limit=100]  - Max number of records to return (1–1000)
 * @param {string|number} [params.level] - Filter by log level
 * @param {string} [params.since] - ISO-8601 timestamp to filter newer logs
 */
const getRecent = (params = {}) => {
	return API.get("/log", { params });
};

// Keep this body-based search separate from getRecent() so older/simple log reads
// can remain query-string GETs while the User Activity admin UI uses POST search.
const search = (payload = {}) => {
	return API.post("/log/search", payload);
};

const LogService = {
	// getAll,
	// get,
	create,
	// update,
	// remove,
	// removeAll,
	// findByTitle,
	getRecent,
	search,
};

export default LogService;
